// extracted by mini-css-extract-plugin
export default {"list":"ConversationBubble_list__drPgW","loadingDots":"ConversationBubble_loadingDots__qJap-","loadingBounce":"ConversationBubble_loadingBounce__CFHHQ"};